import {combineReducers} from "redux"

import massGroupReducer from "./massGroupReducer";
import projectReducer from "./projectReducer";
import gsmResultsReducer from  "./gsmResultsReducer";
import newProjectReducer from "./newProjectReducer";

export default combineReducers({
    massGroupReducer,
    projectReducer,
    gsmResultsReducer,
    newProjectReducer
})